var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Signed out")]),_c('p',[_vm._v("You have signed out of Active Directory. Click "),_c('router-link',{attrs:{"to":"home"}},[_vm._v("here")]),_vm._v(" to navigate to home page.")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }